import { Platform } from 'react-native';

/**
 *
 * @returns true if Platform is 'android', 'ios', 'mac' or 'window'
 */
export const isApp = () => {
  return Platform.OS !== 'web';
};
